import React, { Component } from "react";
import Picker, { registerLocale } from "react-datepicker";
import uk from "date-fns/locale/uk";
// registerLocale("uk", uk);
import "react-datepicker/dist/react-datepicker.css";

export const DatePicker = ({ selected, onChange, className, ...rest }) => (
  <Picker locale={uk} dateFormat="dd/MM/yyyy" selected={selected} className={className} onChange={onChange} {...rest} />
);
